import { queryClient } from '@/libs/tanstackQuery';
import { getInvestmentDetailsQueryKey, getInvestorDeclarationQueryKey } from '@repo/api/services/userBackend/gen';
import { initEventBus } from '@repo/single-spa';
import { useEffect } from 'react';

const eventBus = initEventBus();

/**
 * TT-199: the host loads the investor declaration and investment details once, in the
 * `_authenticated` route loader. That loader does not re-run on child-route navigation, so a
 * customer who completes their declaration inside the Vue parcel keeps seeing the pre-declaration
 * sidebar (no "Investor Hub" link) until a refocus or a full reload. Listening for the Vue page's
 * event and invalidating both reads makes the nav correct itself in place.
 *
 * NOTE: `queryClient` is imported as the module singleton rather than read via `useQueryClient()`
 * on purpose - this component is mounted alongside `PostHogEventHandler` in `AppProviders`, which
 * is OUTSIDE `TanstackQueryProvider`, so there is no QueryClientProvider in scope here. Do not
 * "fix" this to the hook without also moving the mount point inside the provider.
 */
export function InvestorDeclarationEventHandler() {
  useEffect(() => {
    const handleSubmitted = () => {
      queryClient.invalidateQueries({ queryKey: getInvestorDeclarationQueryKey() });
      queryClient.invalidateQueries({ queryKey: getInvestmentDetailsQueryKey() });
    };

    eventBus.on('mife:investor-declaration-submitted', handleSubmitted);

    return () => {
      eventBus.off('mife:investor-declaration-submitted', handleSubmitted);
    };
  }, []);

  return null; // This component doesn't render anything
}
